<div class="sub-menu" (keydown.escape)="onEscapeKey($event)">
    <div class="sub-menu-wrapper">
        <div class="sub-menu-content">
            @if (edito) {
                <div class="menu-edito">
                    <h-menu-bar-edito
                        [edito]="edito"
                        [menuEntry]="menuEntry | asMenuEntryItemWithEdito"
                        (menuEditoClicked)="closeSubMenu.emit()"></h-menu-bar-edito>
                </div>
            }

            <ul
                class="sub-category-list"
                [ngStyle]="{ '--category-max-height': categoryMaxHeight, '--category-min-height': categoryMinHeight }">
                @if (menuEntry && menuEntry.subcategories && menuEntry.subcategories.length) {
                    @for (subMenuEntry of menuEntry.subcategories; track subMenuEntry; let index = $index) {
                        <li class="sub-category-block">
                            @if (subMenuEntry.subcategories && subMenuEntry.subcategories.length > 0) {
                                <span class="sub-category-item label-menu-nav">
                                    {{ subMenuEntry.name }}
                                </span>

                                <ul>
                                    @for (
                                        subSubMenuEntry of subMenuEntry.subcategories;
                                        track subSubMenuEntry;
                                        let subIndex = $index
                                    ) {
                                        <li class="sub-subcategory-link paragraph-small">
                                            <h-menu-bar-link
                                                [menuEntry]="subSubMenuEntry"
                                                [menuLinkLevel]="'menu-link-lvl3'"
                                                [primaryEntry]="menuEntry"
                                                [secondaryEntry]="subMenuEntry"
                                                (keydown)="onKeyDown($event, index, subIndex)"
                                                (menuLinkClicked)="closeSubMenu.emit()"></h-menu-bar-link>
                                        </li>
                                    }
                                </ul>
                            } @else {
                                <h-menu-bar-link
                                    class="sub-category-item label-menu-nav"
                                    [menuEntry]="subMenuEntry"
                                    [menuLinkLevel]="'menu-link-lvl2'"
                                    [primaryEntry]="menuEntry"
                                    (keydown)="onKeyDown($event, index)"
                                    (menuLinkClicked)="closeSubMenu.emit()"></h-menu-bar-link>
                            }
                        </li>
                    }
                }

                @if (menuAboutEntry && menuAboutEntry.items) {
                    @for (subMenuEntry of menuAboutEntry.items; track subMenuEntry; let index = $index) {
                        <li class="sub-category-block">
                            @if (subMenuEntry.items && subMenuEntry.items.length > 0) {
                                <span class="sub-category-item label-menu-nav">
                                    {{ subMenuEntry.label }}
                                </span>

                                <ul>
                                    @for (
                                        subSubMenuEntry of subMenuEntry.items;
                                        track subSubMenuEntry;
                                        let subIndex = $index
                                    ) {
                                        <li class="sub-subcategory-link paragraph-small">
                                            <h-menu-bar-link
                                                [menuAboutEntry]="subMenuEntry"
                                                [menuLinkLevel]="'menu-link-lvl3'"
                                                [primaryAboutEntry]="menuAboutEntry"
                                                [secondaryAboutEntry]="subMenuEntry"
                                                (keydown)="onKeyDown($event, index, subIndex)"
                                                (menuLinkClicked)="closeSubMenu.emit()"></h-menu-bar-link>
                                        </li>
                                    }
                                </ul>
                            } @else {
                                <h-menu-bar-link
                                    class="sub-category-item label-menu-nav"
                                    [menuAboutEntry]="subMenuEntry"
                                    [menuLinkLevel]="'menu-link-lvl2'"
                                    [primaryAboutEntry]="menuAboutEntry"
                                    (keydown)="onKeyDown($event, index)"
                                    (menuLinkClicked)="closeSubMenu.emit()"></h-menu-bar-link>
                            }
                        </li>
                    }
                }
            </ul> </div
    ></div>
</div>
